<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <AddressWarning />
    <b-notification
      type="is-warning"
      aria-close-label="Close notification"
      v-if="hasPendingOrder && !this.newOrder"
      :closable="false"
    >
      Você tem um pedido pendente.
    </b-notification>
    <section>
      <b-table
        :data="data"
        :hoverable="true"
        :striped="true"
        :row-class="rowClass"
        :mobile-cards="true"
        :loading="isLoading"
        default-sort="createdAt"
        default-sort-direction="desc"
        sort-icon="sort-up"
      >
        <template slot-scope="props">
          <b-table-column field="total" label="Valor" sortable>{{
            props.row.total | money
          }}</b-table-column>

          <b-table-column
            field="paymentType"
            label="Forma de pagamento"
            sortable
            >{{ props.row.paymentType | orderPaymentTypes }}</b-table-column
          >

          <b-table-column field="status" label="Status" sortable>
            <b-tag type="is-info">{{ props.row.status | orderStatus }}</b-tag>
          </b-table-column>

          <b-table-column field="createdAt" label="Data" sortable>{{
            props.row.createdAt | dateTime
          }}</b-table-column>

          <b-table-column field="actions" label="Ações">
            <div class="columns">
              <!-- TODO: implementar botão para repetir compra -->
              <!-- <button
                class="button is-rounded is-primary"
                type="submit"
                @click.prevent="validateAndSubmit"
              >
                Repetir
              </button> -->
              <div
                class="column"
                v-if="
                  props.row.status === 'PENDING' &&
                  props.row.paymentType === 'BANKSLIP'
                "
              >
                <b-button
                  class="is-small is-primary"
                  @click.prevent="bankslipDownload(props.row.id)"
                  icon-left="barcode"
                >
                  Baixar boleto
                </b-button>
              </div>
              <div
                class="column"
                v-if="
                  props.row.status === 'PENDING' &&
                  props.row.paymentType === 'BANKSLIP'
                "
              >
                <b-button
                  class="is-small is-primary"
                  @click.prevent="resendInvoice(props.row.id)"
                  icon-left="envelope"
                >
                  Enviar boleto
                </b-button>
              </div>
              <div class="column" v-if="props.row.status === 'PENDING'">
                <b-button
                  class="is-small is-danger"
                  @click.prevent="cancelOrder(props.row.id)"
                  icon-left="trash"
                >
                  Cancelar
                </b-button>
              </div>
              <div
                class="column"
                v-if="
                  props.row.paymentType === 'PIX' &&
                  props.row.status === 'PENDING'
                "
              >
                <b-button
                  class="is-small is-primary"
                  icon-right="qrcode"
                  @click.prevent="openQrCodeModal(props.row)"
                >
                  <span style="margin-right: 5px">Ver QR Code</span>
                </b-button>
              </div>
              <div
                class="column"
                v-if="
                  props.row.status === 'PAYMENT_APPROVED' &&
                  props.row.paymentType === 'BANKSLIP'
                "
              >
                <b-button
                  class="is-small is-primary"
                  @click.prevent="sendReceipt(props.row.id)"
                  icon-left="envelope"
                >
                  Enviar comprovante
                </b-button>
              </div>
              <div class="column" v-if="props.row.id == poolingId">
                <b-icon icon="sync-alt" class="spining" />
              </div>
            </div>
          </b-table-column>
        </template>
        <template slot="empty">
          <section v-if="!isLoading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="sad-tear" size="is-large"></b-icon>
              </p>
              <p>Nenhuma compra</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
    <PixModal
      v-if="isPIxModalOpen"
      :order="currentPixOrder"
      ref="pixModal"
      @close="closePixModal"
    />
  </div>
</template>

<script>
import Vue from "vue";
import ZHeader from "../../layout/Header";
import orders, { orderStatus, paymentTypes } from "../../services/orders";
import { moneyFilter } from "../../filters/money";
import "../../filters/dateTime";
import AddressWarning from "../../components/AddressWarning";
import PixModal from "../../components/PixModal";

Vue.filter("orderStatus", (value) => {
  if (!value) return "";
  value = value.toString();
  return orderStatus[value];
});

Vue.filter("orderPaymentTypes", (value) => {
  if (!value) return "";
  value = value.toString();
  return paymentTypes[value];
});

export default {
  data() {
    return {
      title: "Pedidos de compra de créditos",
      actions: [
        {
          label: "Novo pedido",
          route: "compras/novo",
          class: "is-primary",
        },
      ],
      data: [],
      isLoading: false,
      firstLoad: true,
      poolingId: null,
      isPIxModalOpen: false,
      currentPixOrder: {},
      hasPendingOrder: false,
      newOrder: null,
    };
  },
  mounted() {
    this.loadData();
    this.setFilterList();

    const newOrder = localStorage.getItem("newOrder");
    this.newOrder = newOrder;

    if (newOrder) {
      this.poolingUpdate(newOrder);
      localStorage.removeItem("newOrder");
    }

    this.$root.$on("update-list", () => {
      this.loadData();
      this.setFilterList();
    });
  },
  methods: {
    loadData() {
      this.isLoading = true;

      return orders.all().then((data = []) => {
        this.checkIfHasPendingOrder(data);
        this.data = data;
        this.isLoading = false;
      });
    },
    view(data) {
      this.$router.push(`compras/${data.id}`);
    },
    checkIfHasPendingOrder(orders = []) {
      const pendingOrder = orders
        .slice()
        .reverse()
        .find((order) => order.status === "PENDING");
      const newActions = this.actions.slice();

      this.hasPendingOrder = !!pendingOrder;

      newActions[0].disabled = this.hasPendingOrder;

      this.actions = newActions;
    },
    rowClass() {
      return "is-clickable";
    },
    poolingUpdate(id) {
      this.poolingId = id;
      const interval = 2000;
      const ttl = 20000;

      const pooling = setInterval(async () => {
        const order = await orders.get(id);

        if (order.status !== "PROCESSING") {
          this.isLoading = true;

          const copyData = Object.assign([], this.data);
          const index = copyData.findIndex((row) => row.id === order.id);
          copyData[index] = order;

          this.data = copyData;

          clearInterval(pooling);
          this.poolingId = null;

          this.isLoading = false;

          if (order.status === "PENDING" && order.paymentType === "PIX") {
            this.openQrCodeModal(order, false);
          }
        }
      }, interval);

      // after ttl will kill interval
      setTimeout(() => {
        clearInterval(pooling);
      }, ttl);
    },
    setFilterList() {},
    filterData() {},
    cancelOrder(id) {
      const order = this.data.find((d) => d.id === id);
      this.$buefy.dialog.confirm({
        message: `Você deseja cancelar a compra <strong>${id}</strong> no valor de <strong>${moneyFilter(
          order.total
        )}</strong> em créditos?`,
        onConfirm: async () => {
          try {
            await orders.cancel(id);

            this.$buefy.toast.open({
              message: "Compra cancelada",
              type: "is-success",
            });

            await this.loadData();
          } catch (err) {
            this.$buefy.toast.open({
              message: err.message,
              type: "is-danger",
            });
          }
        },
      });
    },
    resendInvoice(id) {
      this.$buefy.dialog.confirm({
        message: `Você deseja enviar o boleto por email?`,
        onConfirm: async () => {
          try {
            await orders.resendInvoice(id);

            this.$buefy.toast.open({
              message: "Boleto enviado com sucesso",
              type: "is-success",
            });

            await this.loadData();
          } catch (err) {
            this.$buefy.toast.open({
              message: err.message,
              type: "is-danger",
            });
          }
        },
      });
    },
    async bankslipDownload(id) {
      try {
        const order = this.data.find((d) => d.id === id);

        if (order && order.paymentUrl) {
          window.open(order.paymentUrl, "_blank");
        } else {
          throw new Error("Não foi possível baixar o boleto para esse pedido.");
        }
      } catch (err) {
        this.$buefy.toast.open({
          message: err.message,
          type: "is-danger",
        });
      }
    },
    sendReceipt(id) {
      this.$buefy.dialog.confirm({
        message: `Você deseja enviar o comprovante de compra por e-mail?`,
        onConfirm: async () => {
          try {
            await orders.sendReceipt(id);

            this.$buefy.toast.open({
              message: "E-mail enviado",
              type: "is-success",
            });

            await this.loadData();
          } catch (err) {
            this.$buefy.toast.open({
              message: err.message,
              type: "is-danger",
            });
          }
        },
      });
    },
    closePixModal() {
      this.isPIxModalOpen = false;
      this.currentPixOrder = {};
    },
    openQrCodeModal(data, refreshOrder = true) {
      this.currentPixOrder = data;
      this.isPIxModalOpen = true;

      if (refreshOrder) {
        this.$nextTick(() => {
          this.$refs.pixModal.refresh();
        });
      }
    },
  },
  components: {
    ZHeader,
    AddressWarning,
    PixModal,
  },
};
</script>

<style lang="scss">
@-moz-keyframes spin {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spining {
  -webkit-animation-name: spin;
  -webkit-animation-duration: 2000ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: spin;
  -moz-animation-duration: 2000ms;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  -ms-animation-name: spin;
  -ms-animation-duration: 2000ms;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: linear;

  animation-name: spin;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
